import * as React from "react";
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent, AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay, Button
} from "@chakra-ui/react";

export interface DeleteConfirmAlertProps {
    isOpen: boolean
    title: string
    description: string
    onClose: (deleteConfirmed: boolean) => void
}
export const DeleteConfirmAlert = ({isOpen, onClose, title, description}: DeleteConfirmAlertProps) => {
    const cancelRef = React.useRef(null)

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={() => {onClose(false)}}
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {title}
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        {description}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button ref={cancelRef} onClick={() => {onClose(false)}}>
                            Cancel
                        </Button>
                        <Button colorScheme="red" onClick={() => {onClose(true)}} ml={3}>
                            Delete
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}